import { GET_FISH_TYPES_SUCCESS } from "../actionTypes";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_FISH_TYPES_SUCCESS: {
      const fishTypes = action.payload;

      if (!fishTypes){
        return [...state];
      }

      return [
        ...state,
        ...fishTypes
      ]
    }
    default:
      return state;
  }
}
